"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  guildRegisterWindow: {
    id: "window.guildCreate.label.guildRegisterWindow",
    defaultMessage: "Guild Register Window",
    description: ""
  },
  guildName: {
    id: "window.guildCreate.label.guildName",
    defaultMessage: "Guild Name",
    description: ""
  },
  check: {
    id: "window.guildCreate.button.check",
    defaultMessage: "Check",
    description: ""
  },
  guildMark: {
    id: "window.guildCreate.button.guildMark",
    defaultMessage: "Guild Mark",
    description: ""
  },
  markColor: {
    id: "window.guildCreate.button.markColor",
    defaultMessage: "Mark Color",
    description: ""
  },
  cloakColor: {
    id: "window.guildCreate.button.cloakColor",
    defaultMessage: "Cloak Color",
    description: ""
  },
  itNeedsMoney: {
    id: "window.guildCreate.text.itNeedsMoney",
    defaultMessage: "It needs {dividedMoneyString}",
    description: ""
  },
  create: {
    id: "window.guildCreate.button.create",
    defaultMessage: "Create",
    description: ""
  },
  reset: {
    id: "window.guildCreate.button.reset",
    defaultMessage: "Reset",
    description: ""
  }
});

exports.default = _default;